import { ModuleRunsView } from './ModuleRunsView';

/** Модуль «Столовая»: реализация + приход/списание, контроль наценки и
 *  списания продуктов. Механика — см. ModuleRunsView. */
export function CanteenReport() {
  return <ModuleRunsView moduleId="canteen" />;
}
